import PropTypes from "prop-types"
import React from "react"
import PageMetaTags from "components/PageMetaTags"
import { Row, Col, CardBody, Card, Container } from "reactstrap"

// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { resetPassword } from "store/actions"

// import images
import profile from "assets/images/profile-img.png"
import logo from "assets/images/logo.svg"
import { Field, reduxForm } from "redux-form"
import { TextField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import { SaveButton } from "components/Buttons"
import validate from "./resetPasswordValidation"

const ResetPwd = props => {
  let url_token = props.match.params.token
  const handleSave = formValues => {
    let values = { password: formValues.password, api_token: url_token }

    props.resetPassword(values, props.history)
  }

  return (
    <React.Fragment>
      <PageMetaTags title={"Reset password"} />
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Reset password!</h5>
                        {/*<p>Reset you password to enCappture.</p>*/}
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <div className="avatar-md profile-user-wid mb-4">
                      <span className="avatar-title rounded-circle bg-light">
                        <img
                          src={logo}
                          alt=""
                          className="rounded-circle"
                          height="34"
                        />
                      </span>
                    </div>
                  </div>
                  <div className="p-2">
                    <Row>
                      <Col>
                        <Field
                          name="password"
                          type="password"
                          component={TextField}
                          label="Password"
                        />
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col>
                        <Field
                          name="confirmPassword"
                          type="password"
                          component={TextField}
                          label="Confirm Password"
                        />
                      </Col>
                    </Row>
                    <Row className="mt-3 d-grid">
                      <Col>
                        <SaveButton
                          color="primary"
                          content="Log In"
                          loading={props?.loading}
                          fullWidth={true}
                          onClick={props?.handleSubmit(handleSave)}
                        />
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const { error } = state.Login
  return { error }
}

export default withRouter(
  connect(mapStateToProps, { resetPassword })(
    reduxForm({ form: FORM_NAMES.RESET_PWD_FORM, validate: validate })(ResetPwd)
  )
)

ResetPwd.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
}
